import axios from "axios";
import { Notify } from "vant";

const isDev = process.env.NODE_ENV === "development";

const service = axios.create({
  baseURL: isDev ? "" : process.env.VUE_APP_BASE_URL
  // timeout: 15000
});

service.interceptors.request.use(
  config => {
    config.headers["X-PRODUCT"] = process.env.VUE_APP_KEY;
    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    const res = response.data || {};
    const resCode = response.status;
    if (resCode !== 200) {
      Notify(res.message);
      return Promise.reject("error");
    } else {
      // get book content, the response is directly set to res
      return res.data || res;
    }
  },
  error => {
    console.log("err" + error);
    Notify(error.message);
    return Promise.reject(error);
  }
);

export default service;
